package gr.tech.GRAttestation.infrastructure

import gr.tech.GRAttestation.models.attestation.AttestationDTO
import gr.tech.GRAttestation.models.stores.StoreDTO

object ReceiptGeneratorData {
    var store: StoreDTO? = null
    var attestation: AttestationDTO? = null
}